module.exports = __webpack_public_path__ + "img/miniprogram.433e43a4.png";